import PlatformAbi from "./PlatformAbi.json";
import Erc20TokenAbi1 from "./erc20TokenAbi.json";
export default PlatformAbi;
export const Erc20TokenAbi = Erc20TokenAbi1;
export const PlatformContractAddress =
  "0x01937c2BAa3A8F07A484626DDF66cd41d23EfA19";
export const vestingAddress = "0x6F311e0E3C677B6C2f185810cFE8a4C17BC4520B";
